import React from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import { selectFocusedHelper } from "slices/generalSlice";

const HelperScreen = () => {
  // const dispatch = useDispatch();
  const helperActive = useSelector(selectFocusedHelper);
  // const [ready, setReady] = useState(false);

  // useEffect(() => {
  //   setReady(false);
  //   let timer = setTimeout(() => {
  //     setReady(true);
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, [helperActive]);

  // const onClick = (e) => {
  //   e.stopPropagation();
  // };

  if (helperActive)
    return ReactDOM.createPortal(
      <div className="modal-backdrop helper-screen"></div>,
      document.querySelector("#helper-platform") as HTMLElement
    );
  return null;
};

export default HelperScreen;
